// extracted by mini-css-extract-plugin
export default {"value":"viewModal_value__3u3kM"};